// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import getColor from "@insite/mobius/utilities/getColor";
import { ellipsis } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    gap: 20,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    width: [12, 6, 4, 4, 3],
};

categoryDetailSubCategoriesStyles.innerContainer = {
    gap: 0,
    css: css`
        position: relative;
        height: 100%;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    width: 12,
    css: css`
        width: 100%;
        height: 220px;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageClickable = {
    css: css`
        width: 100%;
        height: 100%;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImage = {
    css: css`
        width: 100%;
        height: 100%;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = { width: 12 };

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    css: css`
        width: 100%;
        position: absolute;
        background-color: ${getColor("text")};
        opacity: 0.8;
        height: 50px;
        bottom: 0;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 5px 15px;
        line-height: 18px;
    `,
    color: "common.white",
    typographyProps: {
        weight: "bold",
        size: 15,
        css: css`
            word-wrap: break-word;
            ${ellipsis(2, 18)}
        `,
    },
};
